export default "__VITE_ASSET__2yAXXyG___"